import { apiSlice } from "../apiSlice";

const coachSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCoaching: builder.query({
      query: (coachParams) => ({
        url: `/coach?coach=${coachParams.coach}&message=${coachParams.message}`,
      }),
      keepUnusedDataFor: 5,
    }),
  }),
});

export const { useLazyGetCoachingQuery } = coachSlice;